import { useNavigation } from '@react-navigation/native';
import React, { useState } from 'react';
import {
  ActivityIndicator,
  KeyboardAvoidingView,
  Platform,
  ScrollView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';

import { useAuth } from '../hooks/useAuth';
import { showToast } from '../utils/toast';

export default function RegisterScreen() {
  const navigation = useNavigation();
  const { register, isLoading: loading } = useAuth();

  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [nickname, setNickname] = useState('');

  const handleRegister = async () => {
    if (!phone || !code) {
      showToast('请填写手机号和验证码', 'warning');
      return;
    }
    if (password && password !== confirmPassword) {
      showToast('两次密码输入不一致', 'warning');
      return;
    }
    await register(phone, code, password, nickname);
  };

  return (
    <KeyboardAvoidingView
      style={styles.container}
      behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
    >
      <ScrollView contentContainerStyle={styles.content}>
        <Text style={styles.title}>注册账号</Text>

        <View style={styles.inputSection}>
          <TextInput
            style={styles.input}
            placeholder="手机号"
            value={phone}
            onChangeText={setPhone}
            keyboardType="phone-pad"
            maxLength={11}
            placeholderTextColor="#999"
          />
          <TextInput
            style={styles.input}
            placeholder="验证码"
            value={code}
            onChangeText={setCode}
            keyboardType="number-pad"
            maxLength={6}
            placeholderTextColor="#999"
          />
          <TextInput
            style={styles.input}
            placeholder="设置密码（可选）"
            value={password}
            onChangeText={setPassword}
            secureTextEntry
            maxLength={20}
            placeholderTextColor="#999"
          />
          <TextInput
            style={styles.input}
            placeholder="确认密码（可选）"
            value={confirmPassword}
            onChangeText={setConfirmPassword}
            secureTextEntry
            maxLength={20}
            placeholderTextColor="#999"
          />
          <TextInput
            style={styles.input}
            placeholder="昵称（可选）"
            value={nickname}
            onChangeText={setNickname}
            maxLength={20}
            placeholderTextColor="#999"
          />
        </View>

        <TouchableOpacity
          style={[styles.registerButton, loading && styles.disabledButton]}
          onPress={handleRegister}
          disabled={loading}
        >
          {loading ? (
            <ActivityIndicator color="#fff" />
          ) : (
            <Text style={styles.registerButtonText}>注册</Text>
          )}
        </TouchableOpacity>

        <View style={styles.terms}>
          <Text style={styles.termsText}>注册即表示同意</Text>
          <TouchableOpacity onPress={() => navigation.navigate('Privacy' as any)}>
            <Text style={styles.termsLink}>《隐私协议》</Text>
          </TouchableOpacity>
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  );
}

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#f5f5f5',
    flex: 1,
  },
  content: {
    flex: 1,
    paddingHorizontal: 32,
    paddingVertical: 40,
  },
  disabledButton: {
    backgroundColor: '#ccc',
  },
  input: {
    backgroundColor: '#fff',
    borderRadius: 8,
    color: '#333',
    fontSize: 16,
    height: 50,
    marginBottom: 16,
    paddingHorizontal: 16,
  },
  inputSection: {
    marginBottom: 24,
  },
  registerButton: {
    alignItems: 'center',
    backgroundColor: '#c9a227',
    borderRadius: 8,
    height: 50,
    justifyContent: 'center',
    marginBottom: 16,
  },
  registerButtonText: {
    color: '#fff',
    fontSize: 16,
    fontWeight: 'bold',
  },
  terms: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: 8,
  },
  termsLink: {
    color: '#c9a227',
    fontSize: 14,
  },
  termsText: {
    color: '#666',
    fontSize: 14,
  },
  title: {
    color: '#333',
    fontSize: 28,
    fontWeight: 'bold',
    marginBottom: 32,
    textAlign: 'center',
  },
});
